// @Date: 2023-08-25 15:23:55
// @LastEditors: phil_litian


export const aTabs = [
	{ langCode: 'appointment_waitlist', code: 'waitlist', status: 'waitlist' },
	{ langCode: 'appointment_upcoming', code: 'upcoming', status: '0' },
	{ langCode: 'appointment_finished', code: 'finished', status: '1' },
	{ langCode: 'appointment_cancelled', code: 'cancelled', status: '2' },
];

export const dateMap = {
	'en': 'DD MMMM HH:mm',
};



